import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ed87376&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed87376')) {
      api.createRecord('4ed87376', component.options)
    } else {
      api.reload('4ed87376', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ed87376&", function () {
      api.rerender('4ed87376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/school/index.vue"
export default component.exports